import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRoute, QueryParamsHandling, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {isDefined, isEmpty, routePath} from 'sdv-common';
import {keys, reload, restApi} from '../shared/constants';

@Injectable({providedIn: 'root'})
export class ApiService {

  constructor(private router: Router,
              private http: HttpClient,
              private route: ActivatedRoute,
              private cookieService: CookieService) {
  }

  setParams(params, handling: QueryParamsHandling = 'merge') {
    this.router.navigate([], {
      queryParamsHandling: handling,
      skipLocationChange: false,
      relativeTo: this.route,
      queryParams: params
    });
  }

  getParam(key: string, defaultValue = null) {
    return this.route.snapshot.queryParamMap.get(key) || defaultValue;
  }

  error(holder, err) {
    err = err.error;
    holder.error = '[' + err.id + '] ' + err.message;
    console.log('error', err);
  }

  get(path, params = {}, headers = {}): any {
    headers = this.performHeaders(headers);
    return this.http.get<any>(restApi.build(path), {headers, params});
  }

  post(path, body, headers = {}): any {
    headers = this.performHeaders(headers);
    return this.http.post<any>(restApi.build(path), body, {headers});
  }

  patch(path, body, headers = {}): any {
    headers = this.performHeaders(headers);
    return this.http.patch<any>(restApi.build(path), body, {headers});
  }

  put(path, body, headers = {}): any {
    headers = this.performHeaders(headers);
    return this.http.put<any>(restApi.build(path), body, {headers});
  }

  delete(path, params = {}, headers = {}): any {
    headers = this.performHeaders(headers);
    return this.http.delete<any>(restApi.build(path), {headers, params});
  }

  private performHeaders(headers: {}) {
    headers = {
      'Access-Control-Allow-Origin': '*',
      'Accept': 'application/json',
      ...headers
    };

    let token = this.getToken();
    if (token) {
      headers['Authorization'] = 'Bearer ' + token;
    }
    return headers;
  }

// todo auth https://jasonwatmore.com/post/2019/06/22/angular-8-jwt-authentication-example-tutorial
  getToken(): string {
    let token = this.cookieService.get(keys.sid);
    if (token) { // prolong token if exists
      const expires = new Date();
      expires.setDate(expires.getDate() + 1);
      this.cookieService.set(keys.sid, token, expires);
    }
    return token;
  }

  getJwtToken(): any {
    return JSON.parse(atob(this.getToken().split('.')[1]));
  }

  isAnonymous(): boolean {
    return isEmpty(this.getToken());
  }

  isAuthorized(): boolean {
    return !this.isAnonymous();
  }

  signOut() {
    this.cookieService.delete(keys.sid);
    reload(routePath.home);
  }

  hasRole(role) {
    if (this.isAnonymous()) {
      return false;
    }
    const fullRole = ['ROLE_', role].join('');
    return isDefined((this.getJwtToken().scope || []).find(n => n === fullRole));
  }
}
